import { useLayoutEffect, useRef } from 'react';
import { usePrevious } from 'hooks/usePrevious';
import RcVirtualList, { type ListProps, type ListRef } from 'rc-virtual-list';

export type VirtualListProps<T> = Omit<ListProps<T>, 'itemKey'> & {
  maxHeight?: number;
  itemKey?: React.Key | ((item: T) => React.Key);
};

function VirtualList<Item>({
  maxHeight = 142,
  itemKey = 'key',
  style,
  data,
  itemHeight = 36,
  ...rest
}: VirtualListProps<Item>) {
  const virtualListRef = useRef<ListRef>(null);
  const prevData = usePrevious<Item[]>(data) || [];
  useLayoutEffect(() => {
    if (virtualListRef.current && data.length === prevData.length + 1) {
      virtualListRef.current.scrollTo(data.length * itemHeight);
    }
  }, [data, virtualListRef]);

  return (
    <RcVirtualList
      itemKey={itemKey}
      style={{ maxHeight, overflow: 'auto', ...style }}
      height={Math.min(data.length * itemHeight, maxHeight)}
      ref={virtualListRef}
      data={data}
      {...rest}
    />
  );
}

export default VirtualList;
